import React from 'react';
import './Home.css';

// Import required components and constants
import { Button } from '../../../components';
import { home } from '../../../constants';

// Import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { FaFire } from 'react-icons/fa';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const Home = () => {

  return (
    <section className='home'>

      {/* Home Slider Container */}
      <div className='home-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Navigation, Pagination, Autoplay]}
          loop={true} // Enables infinite looping
          autoplay={{ delay: 5000, disableOnInteraction: true }} // Auto-slide settings
          navigation // Enables navigation buttons
          pagination={{ clickable: true }} // Enable pagination dots
        >
          {home.map((item) => {
            return (
              <SwiperSlide className='home-item' key={item.id}>

                {/* Background image for each slide */}
                <img src={item.image} alt="Home-Pic" />

                {/* Content overlay */}
                <div className="content">
                  <div className="text">
                    <h5><FaFire />{item.subtitle}<FaFire /></h5> {/* Subtitle with Fire icons */}

                    <h3>
                      {
                        item.title.includes('{') ? (
                          <>
                            {item.title.split('{')[0]}
                            <span>{item.title.split('{')[1].split('}')[0]}</span>
                            {item.title.split('}')[1]}
                          </>
                        ) : item.title
                      }
                    </h3>  {/* Main heading */}

                    <Button link={item.buttonLink} title={item.buttonText} /> {/* CTA Button */}
                  </div>
                </div>

              </SwiperSlide>
            )
            })
          }
        </Swiper>
      </div>
    </section>
  )
}

export default Home;